import React from 'react';
import UpdatePasswordForm, {SetPasswordForm} from '../../people/me/UpdateProfile/UpdatePasswordForm';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import {SettingsBreadcrumbs} from '../settingsModule';
import {Breadcrumb} from '../../shared/web/layout/Breadcrumbs';
import {InformationMessage, Separator} from 'features/nekst-widgets';
import OAuthLinksWidget from './components/OAuthLinksWidget';
import useFeatureToggleService, {GoogleSignInToggleWrapper, ToggledFeature} from "feature-toggle";
import {useAuthenticationContextRequired} from "nekst-api";

export default function PasswordAndLoginMethodsPage() {

  const featureToggleService = useFeatureToggleService();

  const authenticationContext = useAuthenticationContextRequired();

  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text={featureToggleService.isFeatureEnabled(ToggledFeature.GOOGLE_SIGNIN) ? "Login Details" : 'Password Update'} />
      </SettingsBreadcrumbs>

      <InnerBlock title="Password">
        <div style={{ maxWidth: '65rem' }}>
          {authenticationContext.user._hasPassword && <UpdatePasswordForm />}
          {!authenticationContext.user._hasPassword && (
              <>
                <InformationMessage>
                    Your do not have a password set. Please set a password to enable password login.
                </InformationMessage>
                <SetPasswordForm />
              </>
            )}
        </div>
      </InnerBlock>
      <GoogleSignInToggleWrapper>
        <Separator marginSize="big" />

        <InnerBlock title="Connected Accounts">
          <OAuthLinksWidget />
        </InnerBlock>
      </GoogleSignInToggleWrapper>
    </>
  );
}
